<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-container class="py-0 fill-height">
        <router-link :to="{ name: 'home' }">
          <v-img
            alt="rekord"
            class="shrink mr-10"
            contain
            :src="require('./assets/rekord-logo.jpg')"
            max-height="50px"
            width="100"
            transition="scale-transition"
          />
        </router-link>

        <v-btn v-if="!user.anonymous" text :to="{ name: 'admin' }">
          Admin
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn v-if="!user.anonymous" text :to="{ name: 'logout' }">
          Logg ut
        </v-btn>
        <v-btn v-else text :to="{ name: 'login' }"> Logg inn </v-btn>
      </v-container>
    </v-app-bar>

    <v-content>
      <Messages :messages="messages" />

      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Messages from "@/components/Messages";

export default {
  name: "App",

  components: {
    Messages,
  },

  computed: {
    user() {
      return this.$store.state.auth;
    },

    messages() {
      return this.$store.state.messages.messages;
    },
  },
};
</script>
